/* WISAMIN · build-your-own-set (bundle builder) */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Format cents with the store's own money format, so it follows the store currency. */
  function makeMoney(fmt) {
    return function (cents) {
      var n = (cents || 0) / 100;
      var body = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var noZero = n.toLocaleString('en-US', {
        minimumFractionDigits: n % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
      if (!fmt) return 'S$' + noZero;
      return fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(n).toLocaleString('de-DE'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, n.toLocaleString('de-DE', { minimumFractionDigits: 2 }))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(n).toLocaleString('en-US'))
        .replace(/\{\{\s*amount_without_trailing_zeros\s*\}\}/g, noZero)
        .replace(/\{\{\s*amount\s*\}\}/g, body);
    };
  }

  function init(section) {
    var bar = section.querySelector('[data-wb-bar]');
    var grid = section.querySelector('[data-wb-grid]');
    if (!bar || !grid) return;

    var money = makeMoney(bar.getAttribute('data-money-format'));
    var toCheckout = bar.getAttribute('data-checkout') === 'true';

    var tiers = [].slice.call(section.querySelectorAll('[data-wb-tier]'))
      .map(function (el) {
        return {
          el: el,
          qty: parseInt(el.getAttribute('data-qty'), 10) || 0,
          pct: parseFloat(el.getAttribute('data-pct')) || 0,
          code: (el.getAttribute('data-code') || '').trim()
        };
      })
      .filter(function (t) { return t.qty > 0 && t.pct > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });

    var elCount = bar.querySelector('[data-wb-count]');
    var elNext = bar.querySelector('[data-wb-next]');
    var elWas = bar.querySelector('[data-wb-was]');
    var elNow = bar.querySelector('[data-wb-now]');
    var elSave = bar.querySelector('[data-wb-save]');
    var elCta = bar.querySelector('[data-wb-add]');
    var emptyNote = elNext ? elNext.textContent : '';

    function cards() { return [].slice.call(grid.querySelectorAll('[data-wb-card]')); }

    function readAttr(card, name) {
      var v = card.querySelector('[data-wb-var]');
      if (!v) return 0;
      var src = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
      return src ? parseInt(src.getAttribute(name), 10) || 0 : 0;
    }

    function unitPrice(card) { return readAttr(card, 'data-price'); }
    function unitCompare(card) { return readAttr(card, 'data-compare'); }

    /* Keep each card's price, strike-through compare price and -NN% badge in
       sync with the variant the shopper picked. */
    function paintCard(card) {
      var price = unitPrice(card);
      var cmp = unitCompare(card);
      var off = cmp > price && cmp > 0 ? Math.round((cmp - price) * 100 / cmp) : 0;

      var box = card.querySelector('[data-wb-price]');
      if (box) {
        var b = box.querySelector('b');
        if (b) b.textContent = money(price);
        var strike = box.querySelector('s');
        if (off > 0) {
          if (!strike) { strike = document.createElement('s'); box.appendChild(strike); }
          strike.textContent = money(cmp);
          strike.hidden = false;
        } else if (strike) {
          strike.hidden = true;
        }
      }

      var badge = card.querySelector('[data-wb-off]');
      if (badge) {
        badge.hidden = off === 0;
        if (off > 0) badge.textContent = '-' + off + '%';
      }
    }

    function variantId(card) {
      var v = card.querySelector('[data-wb-var]');
      return v ? Number(v.value) : 0;
    }

    function qtyOf(card) {
      var o = card.querySelector('[data-wb-n]');
      return o ? parseInt(o.textContent, 10) || 0 : 0;
    }

    function setQty(card, n) {
      var o = card.querySelector('[data-wb-n]');
      if (!o) return;
      o.textContent = n;
      card.classList.toggle('is-on', n > 0);
    }

    function tierFor(n) {
      var hit = null;
      for (var i = 0; i < tiers.length; i++) if (n >= tiers[i].qty) hit = tiers[i];
      return hit;
    }

    function nextTier(n) {
      for (var i = 0; i < tiers.length; i++) if (n < tiers[i].qty) return tiers[i];
      return null;
    }

    function render() {
      var n = 0, gross = 0;
      cards().forEach(function (c) {
        var q = qtyOf(c);
        n += q;
        gross += q * unitPrice(c);
        paintCard(c);
      });

      var t = tierFor(n);
      var pct = t ? t.pct : 0;
      var cut = Math.round(gross * pct / 100);
      var net = gross - cut;

      tiers.forEach(function (x) { x.el.classList.toggle('is-on', !!t && x.qty === t.qty); });

      bar.hidden = n === 0;
      if (elCount) elCount.textContent = n === 1 ? '1 item' : n + ' items';
      if (elNow) elNow.textContent = n ? money(net) : '—';

      if (elWas) {
        elWas.hidden = cut === 0;
        elWas.textContent = cut ? money(gross) : '';
      }
      if (elSave) {
        elSave.hidden = cut === 0;
        elSave.textContent = cut ? 'Save ' + money(cut) + ' (' + pct + '%)' : '';
      }

      if (elNext) {
        var nx = nextTier(n);
        if (!n) elNext.textContent = emptyNote;
        else if (nx) elNext.textContent = 'Add ' + (nx.qty - n) + ' more for ' + nx.pct + '% off';
        else if (t) elNext.textContent = 'Best tier unlocked · ' + t.pct + '% off';
        else elNext.textContent = emptyNote;
      }

      if (elCta) elCta.disabled = n === 0;
    }

    grid.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-wb-plus]');
      var minus = e.target.closest('[data-wb-minus]');
      if (!plus && !minus) return;
      var card = e.target.closest('[data-wb-card]');
      if (!card) return;
      var q = qtyOf(card);
      setQty(card, plus ? Math.min(q + 1, 20) : Math.max(q - 1, 0));
      render();
    });

    grid.addEventListener('change', function (e) {
      if (e.target.matches('[data-wb-var]')) render();
    });

    if (elCta) {
      elCta.addEventListener('click', function () {
        var items = [];
        cards().forEach(function (c) {
          var q = qtyOf(c), id = variantId(c);
          if (q > 0 && id) items.push({ id: id, quantity: q });
        });
        if (!items.length) return;

        var n = items.reduce(function (a, b) { return a + b.quantity; }, 0);
        var t = tierFor(n);
        var label = elCta.textContent;
        elCta.disabled = true;
        elCta.textContent = 'Adding…';

        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.ok ? r.json() : r.json().then(function (x) { throw x; }); })
          .then(function () {
            var dest = toCheckout ? 'checkout' : 'cart';
            if (t && t.code) {
              window.location.href = root() + 'discount/' + encodeURIComponent(t.code) +
                '?redirect=' + encodeURIComponent(root() + dest);
              return;
            }
            window.location.href = root() + dest;
          })
          .catch(function (err) {
            elCta.disabled = false;
            elCta.textContent = label;
            var msg = (err && err.description) ? err.description : 'Could not add the set. Please try again.';
            if (typeof window.wpToast === 'function') window.wpToast(msg); else alert(msg);
          });
      });
    }

    render();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('#wp-bundle')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector ? e.target.querySelector('#wp-bundle') : null;
    if (s) init(s);
  });
})();
